import ShiftLengthJSON from 'app/assets/jsons/ShiftLengths.json';

export function GetShiftLengths() {
  const data = ShiftLengthJSON.shiftLengths;
  return data;
}
